import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from 'react-bootstrap'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../context/SocketContext'
import { useHideMenu } from '../hooks/useHideMenu'
import { useGetPantallas } from '../hooks/useGetPantallas'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'


import LoadingOverlay from '../components/LoadingOverlay'
import { NoAcceso } from '../components/NoAcceso'
import { SelectElement } from '../components/selectElement'
import TiposAtenHorarios from './TiposAtenHorarios'

const server_url=  process.env.REACT_APP_PRODUCCION;  


const pasarMayusculas= (ev) =>{
    ev.preventDefault();
    ev.target.defaultValue= ev.target.defaultValue.toUpperCase();
    ev.target.value= ev.target.value.toUpperCase();
}


const MySwal = withReactContent(Swal);

const sweet = ( title, html, icon ) =>{ MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000  }) }
    
const sweetConfirm = ( title, html, icon ) =>{  
    return MySwal.fire({ 
                    title, 
                    html, 
                    icon, 
                    confirmButtonText: 'Ok',
                    confirmButtonColor: 'LightSeaGreen',  
                    showCancelButton: true, 
                    cancelButtonColor: '#d33',  
                    cancelButtonText: 'Cancelar' 
                }) 
}

export const TiposAtencion = () => {
    
    let [usuario] = useState( getUsuarioStorage() );
    const entidad = usuario.entidad;
    const pantallas = useGetPantallas();

   
    const navigate = useNavigate();
    useEffect(() => {
        if(usuario.uidUsuario === null){
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate])

    useHideMenu(false);
    
    const { socket } = useContext( SocketContext );

    const [ isLoading, setIsLoading ] = useState(false);
    const [ iconos, setIconos ] = useState([]);
    const [ iconoRegistro, setIconoRegistro ] = useState("");
    
    // let [usuario] = useState( getUsuarioStorage() );
    // const entidad = usuario.entidad;

    
    
    // tabla
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    let   [sortedBy, setSortedBy] = useState('tipoAtencion');
    let   [sortDirection, setSortDirection] = useState('asc');

    const [tiposAtencion, setTiposAtencion] = useState([]);
    const [showHorarios, setShowHorarios] = useState(false);
    const [horarios, setHorarios] = useState([]);
    const [selectedTipo, setSelectedTipo] = useState(null);


    const datos={
        entidad,
        search : searchTerm || '',
        page: currentPage || '',
        itemsPerPage: itemsPerPage || '',
        sortedBy: sortedBy,
        sortDirection: sortDirection,
        
    }

    /*********************horarios de atencion  */

   // cargar tipos de atención
    useEffect(() => {
        console.log(entidad);
        
        fetch(`${server_url}/api/tiposatencionparahorario/${entidad}`)
        .then(res => res.json())
        .then(data => {
            setTiposAtencion(data)
            console.log(data);
            
        })
        .catch(err => console.error("Error cargando tipos:", err));
    }, []);

    const handleOpenHorarios = async (uidTipoAtencion, nombre) => {
        setSelectedTipo({ uidTipoAtencion, nombre });
        try {
            const res = await fetch(`${server_url}/horariostiposatencion/${entidad}/${uidTipoAtencion}`);
            const data = await res.json();
            setHorarios(data.horarios);
            setShowHorarios(true);
        } catch (err) {
        console.error("Error cargando horarios:", err);
        }
    };

    const handleAddHorario = async (nuevo) => {

        try {
            const res = await fetch(`${server_url}/horariostiposatencion`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                ...nuevo,
                entidad,
                uidTipoAtencion: selectedTipo.uidTipoAtencion,
                }),
            });
            const data = await res.json();
            console.log(data);
            if(data.ok){
                setHorarios([...horarios, nuevo]);
            }else{
                setHorarios([...horarios]);

            }
        } catch (err) {
            console.error("Error agregando horario:", err);
        }
    };

    const handleEditHorario = async (h) => {
        try {
            const res = await fetch(`${server_url}/horariostiposatencion/${entidad}/${h.ideAgenda}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(h),
            });
            const data = await res.json();
            console.log(data);
            
            if(data.ok){
                setHorarios(
                    horarios.map((x) => (x.ideAgenda === h.ideAgenda ? h : x))
                );
            }
        } catch (err) {
            console.error("Error editando horario:", err);
        }
    };

    const handleDeleteHorario = async (ideAgenda) => {
        try {
            console.log(ideAgenda);
            
            const res = await fetch(`${server_url}/horariostiposatencion/${entidad}/${ideAgenda}`, {
                method: "DELETE",
            });
            const data = await res.json();
            console.log(data);
            
            if(data.ok){
                setHorarios(horarios.filter((h) => h.ideAgenda !== ideAgenda));
            }
        } catch (err) {
        console.error("Error eliminando horario:", err);
        }
    };



    /*********************horarios de atencion  */
  
    useEffect(() => {
      
        async function fetchData() {
            await socket.on('lista-TiposAtencion', ( lista ) => setData( lista ))
        }

        fetchData();

        return () => {
            socket.off('lista-TiposAtencion')
        }
    }, [socket])


    useEffect(() => {
        async function fetchData() {
            await socket.emit('select-iconos', data, ( lista ) => {
                const opciones = lista.map( (item) => ( { value: item.codigoIcono, label: ( <> <i className={`${item.codigoIcono} `}></i></>) } ) )
                setIconos( opciones )
            })
        }

        fetchData();
               
        return () => {
            socket.off('select-iconos')
        }
    }, [  ])
   
    const handleSort = async (header) => {
        console.log(header)    
        

        setSortedBy(header);
        const direction= sortDirection === 'asc' ? 'desc' : 'asc'
        setSortDirection( direction );
        datos.sortedBy= header;
        datos.sortDirection= direction;
        // const l = datos.ordenar.find(x => x.sortedBy === header);
        // return console.log(l)
        setIsLoading(true);
        socket.emit( 'lista-TipoAtencion', datos, async ( lista ) => {
            setIsLoading(false);
            setData(lista);
        })
           
        
    }
    
   
    const reiniciarConsecutivos = async () => {
        
        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la infromación', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la infromación', 'error');

        const confirmacion = await sweetConfirm( "Atención", "Esta seguro de reiniciar la numeración?", "warning" ).then( (result) => {
            return (result);
        })
        
        if (!confirmacion.value) return false;

        
        setIsLoading(true);
        socket.emit( 'reinicia-TiposAtencion', datos, ( res ) => {
            setIsLoading(false);
            
            console.log( res )
        })
    }

    const inactivaTipoAtencion = async (uidTipoAtencion, accion) => {
        
        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la infromación', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la infromación', 'error');

        const confirmacion = await sweetConfirm( "Atención", "Esta seguro de Activar el registro?", "warning" ).then( (result) => {
            return (result);
        })
        
        if (!confirmacion.value) return false;

        datos.uidTipoAtencion= uidTipoAtencion;
        datos.accion= accion;
    
        setIsLoading(true);
        socket.emit( 'inactiva-TipoAtencion', datos, ( res ) => {
            setIsLoading(false);
            console.log( res )
        })

    }

    const onChangeIconoRegistro = (ev) =>{
        setIconoRegistro(ev.value)
    }

    const onChangeIconoEdita = (ev, uidTipoAtencion) => {

        const campo= "icono";
        const valor= ev.value;
        
            datos.campo = campo;
            datos.valor = valor;
            datos.uidTipoAtencion = uidTipoAtencion;
    
            setIsLoading(true);
            socket.emit( 'edita-TipoAtencion', datos, async ( res ) => {
                setIsLoading(false);
                console.log(res)
                if( res === null){
                    
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    console.log(res)

                }else if( res[0] === ""){
                    
                    sweet('Atención!', res[1], 'error');
                    
                }else if( res[0] === 1){
                    
                    delete datos[campo];
                    delete datos[valor];
                    delete datos[uidTipoAtencion];
                                           
                }else{
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    console.log(res);
                }
            })
    }

    const registraTipoAtencion = async ( uidTipoAtencion ) => {

        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la información', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la información', 'error');

        datos.tipoAtencion    = document.getElementById(`tipoAtencion_${uidTipoAtencion}`).value.toUpperCase();
        datos.identificador   = document.getElementById(`identificador_${uidTipoAtencion}`).value.toUpperCase();
        datos.icono           = iconoRegistro;
        datos.sigla           = document.getElementById(`sigla_${uidTipoAtencion}`).value.toUpperCase();
        datos.orden           = document.getElementById(`orden_${uidTipoAtencion}`).value;
        datos.prioritario     = document.getElementById(`prioritario_${uidTipoAtencion}`).value;
        datos.cantidad        = document.getElementById(`cantidad_${uidTipoAtencion}`).value;
        datos.chkPrioritario  = document.getElementById(`chkPrioritario_${uidTipoAtencion}`).checked;
        console.log(datos)
        const registros = document.querySelectorAll('.registro');
        let band = true;
        registros.forEach((elemento, index) => {
            if( elemento.value === "" && elemento.type !== "checkbox" ) {
                band= false;
                return sweet('Atención!', 'Revise la información', 'error');
            }
            if( elemento.value < 0    && elemento.type !== "checkbox" ){
                band= false;
                return sweet('Atención!', 'Revise la información', 'error');  
            } 
        });

        if (!band) return false;
        
        setIsLoading(true);
        socket.emit( 'registra-TipoAtencion', datos, async ( res ) => {
            
            setIsLoading(false);

            if( res[0] === ""){
                sweet('Atención!', res[1], 'error');
            }else if( res[0] === 1){
                sweet('', res[1], 'success');
                
                registros.forEach((elemento, index) => {
                    if( elemento.type !== "checkbox" ) elemento.value = ""
                    else elemento.checked= false;
                    delete datos[elemento.id.split("_")[0]];
                })   
            }else{
                console.log(res);
            }

          

        })

        

    }

    const editaTipoAtencion = async ( ev, uidTipoAtencion) =>{

        const campo= ev.target.id.split("_")[0];
        const valor= ( ev.target.type === 'checkbox' ) ? ev.target.checked : ev.target.value;
        const valorAnterior= ( ev.target.type === 'checkbox' ) ? ev.target.checked : ev.target.defaultValue;
        console.log(valor, valorAnterior)
        console.log(campo)
        console.log(datos)
        

        if ( valor !== valorAnterior || ev.target.type === 'checkbox' ){

            datos.campo = campo;
            datos.valor = valor;
            datos.uidTipoAtencion = uidTipoAtencion;
    
            setIsLoading(true);
            socket.emit( 'edita-TipoAtencion', datos, async ( res ) => {
                setIsLoading(false);
                console.log(res)
                if( res === null){
                    
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    ev.target.value = valorAnterior;
                    console.log(res)

                }else if( res[0] === ""){
                    
                    sweet('Atención!', res[1], 'error');
                    ev.target.value = valorAnterior;

                }else if( res[0] === 1){
                    
                    delete datos[campo];
                    delete datos[valor];
                    delete datos[uidTipoAtencion];
                                           
                }else{
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    console.log(res);
                }
    
            })

        }

        
    }

    
    
    // **************************table
   
   
    useEffect(() => {

        setIsLoading(true)
        socket.emit( 'lista-TipoAtencion', datos, async ( lista ) => {
            setIsLoading(false)
            setData(lista);
        })
        // // Fetch data from your backend API here
        // fetch(`http://http://178.128.152.77:8080/api/tiposAtencion/${entidad}?search=${searchTerm}&page=${currentPage}&itemsPerPage=${itemsPerPage}`)
        // .then((response) => response.json())
        // .then((result) => {
        //     setData(result.data);
        // })
        // .catch((error) => {
        //     console.error('Error fetching data:', error);
        // });


    }, [searchTerm, currentPage, itemsPerPage]);
   


    
    const handleSearch = (ev) => {
        setSearchTerm(ev.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const currentItems =  data.slice(0, itemsPerPage);
    
    
    if( usuario.uidUsuario === null ) {
        return( <></>) 
    }
    else if( !pantallas.includes("tiposatencion") ) {
        return( <NoAcceso /> )
    }else{
        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{minHeight:'100vdh'}}>
                    
                    <div>
                        <div className='row'>
                            <div className='col-lg-2 col-12 '>
                                <button
                                    className='btn btn-primary m-3'
                                    onClick={() => reiniciarConsecutivos()}
                                >
                                Reiniciar Consecutivos
                                </button> 
                                
                            </div>

                            <div className='col-lg-2 col-12 '>
                                <button
                                    className='btn btn-success m-3'
                                    data-bs-toggle="collapse" 
                                    data-bs-target="#divAgregaTipoAtencion"
                                >
                                Agregar Tipo Atención
                                </button> 
                                
                            </div>
                        </div>

                        <div id='divAgregaTipoAtencion'  className='row border border-info rounded shadow p-3 collapse hide'>
                            <Table responsive striped hover style={{minWidth: 1200 }} >
                                <thead>
                                    <tr>
                                        <th ></th>
                                        <th >Tipo Atención</th>
                                        <th >Complemento</th>
                                        <th >Imagen</th>
                                        <th >Color</th>
                                        <th >Ident.</th>
                                        <th >Sigla</th>
                                        <th >Orden</th>
                                        <th >Atn. Prioritaria</th>
                                        <th >Atn. Corriente</th>
                                        <th >ind Prioridad</th>
                                    </tr>
                                </thead>
                                <tbody  >
            
                                    <tr>
                                        <td className='m-1'>
                                            <button
                                                className='btn btn-sm btn-primary me-1'
                                                onClick={ ()=> registraTipoAtencion('') }
                                            > 
                                            <i className='fas fa-save'></i>
                                            </button> 

                                        </td>
                                        <td > 
                                            <input
                                                type='text'
                                                className='form-control registro'
                                                id='tipoAtencion_'
                                            />
                                        </td>
                                        <td > 
                                            <input
                                                type='text'
                                                className='form-control'
                                                id='complemento_'
                                            />
                                        </td>
                                        <td >
                                            <SelectElement
                                                options= { iconos }
                                                name={ `icono_`}
                                                isMulti= {false}
                                                closeOnMenuSelect= {true}
                                                onChange= {(ev) => onChangeIconoRegistro(ev)}
                                                isClearable = {false}
                                            />
                                        </td>
                                        <td >
                                            <input
                                                type="color"
                                                className="form-control form-control-color p-1"
                                                id={`color_`}
                                                defaultValue={"#000000"}
                                                title="Elija un color"
                                                style={{ height: '38px', width: '100%' }}
                                            />

                                        </td>
                                        <td> 
                                            <input
                                                type='text'
                                                className='form-control registro'
                                                maxLength={2}
                                                id='identificador_'
                                            />
                                        </td>
                                        <td >
                                            <input
                                                type= 'text'
                                                className='form-control registro'
                                                id='sigla_'
                                            />

                                            
                                        </td>
                                        <td >
                                            <input
                                                type= 'number'
                                                className='form-control registro'
                                                id='orden_'
                                            />
                                        </td>
                                        <td >
                                            <input
                                                type= 'number'
                                                className='form-control registro'
                                                id='prioritario_'
                                            />
                                        </td>
                                        <td >
                                            <input
                                                type= 'number'
                                                className='form-control registro'
                                                id='cantidad_'
                                            />
                                        </td>
                                        <td >
                                            <div className="form-check form-switch">
                                                <input className="form-check-input registro" type="checkbox" id="chkPrioritario_" />
                                                <label className="form-check-label" htmlFor="chkPrioritario_"></label>
                                            </div>
                                        </td>
                                    </tr>
                                
                                </tbody>
                            </Table>

                        </div>

                        <hr />

                        

                        <div className='row rounded shadow p-3 '>

                            <div className='col-12'>
                                <div className='float-start col-lg-4 col-12 pagination'>
                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                    {"<"}
                                    </button> 
                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(currentPage + 1)}
                                        disabled={currentItems.length < itemsPerPage}
                                    >
                                    {">"}
                                    </button>
                                </div>
                        
                                <div className=' float-end col-lg-4 col-12'>

                                    <input
                                        type='text'
                                        placeholder='Buscar...'
                                        className='form-control'
                                        defaultValue={searchTerm}
                                        onChange={ (ev) => handleSearch(ev)}
                                    />

                                </div>
                            
                            </div>

                            <div className='col-12'>
                                <Table responsive striped hover style={{minWidth: 1200}} className='max600'>
                                    <thead>
                                        <tr>
                                            <th ></th>
                                            <th ></th>
                                            <th  onClick={ () => handleSort('tipoAtencion') } >
                                                Tipo Atención
                                                {sortedBy === 'tipoAtencion' && sortDirection === 'asc' && '▲'}
                                                {sortedBy === 'tipoAtencion' && sortDirection === 'desc' && '▼'}
                                            </th>
                                            <th >Complemento</th>
                                            <th >Imagen</th>
                                            <th >Color</th>
                                            <th >Ident.</th>
                                            <th >Sigla</th>
                                            <th onClick={ () => handleSort('orden') }>
                                                Orden
                                                {sortedBy === 'orden' && sortDirection === 'asc' && '▲'}
                                                {sortedBy === 'orden' && sortDirection === 'desc' && '▼'}
                                            </th>
                                            <th >Atn. Prioritaria</th>
                                            <th >Atn. Corriente</th>
                                            <th >Consec.</th>
                                            <th >ind Prioridad</th>
                                        </tr>
                                    </thead>
                                    <tbody width={'100%'}  >
                                        {currentItems.map((item) => (

                                            <tr key={item.uidTipoAtencion}>
                                                <td >
                                                
                                                    {   (item.indActivo=== 1) 
                                                        ?(
                                                            <button
                                                                className='btn btn-sm btn-danger'
                                                                onClick={() => inactivaTipoAtencion( item.uidTipoAtencion, 0 ) }
                                                            > 
                                                            <i className='fa-solid fa-minus'></i>
                                                            </button>
                                                        )
                                                        :(
                                                            <button
                                                                className='btn btn-sm btn-success'
                                                                onClick={() => inactivaTipoAtencion( item.uidTipoAtencion, 1 ) }
                                                            > 
                                                            <i className='fa-solid fa-plus'></i>
                                                            </button>
                                                        )
                                                    
                                                    }
                                                    


                                                </td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-warning"
                                                        onClick={() =>
                                                            handleOpenHorarios(item.uidTipoAtencion, item.tipoAtencion)
                                                        }
                                                        >
                                                        ⏰
                                                    </button>   
                                                </td>
                                                <td > 
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        id={`tipoAtencion_${item.uidTipoAtencion}`}
                                                        defaultValue={item.tipoAtencion.toUpperCase()}
                                                        onBlur={ (ev) => editaTipoAtencion( ev, item.uidTipoAtencion)}
                                                        onChange={ (ev) => pasarMayusculas( ev )}
                                                    />
                                                </td>
                                                <td > 
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        id={`complemento_${item.uidTipoAtencion}`}
                                                        defaultValue={item.complemento}
                                                        onBlur={ (ev) => editaTipoAtencion( ev, item.uidTipoAtencion)}
                                                        
                                                    />
                                                </td>
                                                <td > 
                                                    <SelectElement
                                                        options= { iconos }
                                                        name={ `icono_${item.uidTipoAtencion}`}
                                                        isMulti= {false}
                                                        closeOnMenuSelect= {true}
                                                        onChange= {(ev) => onChangeIconoEdita(ev, item.uidTipoAtencion)}
                                                        classname= ""
                                                        seleccionado= {item.icono}
                                                        isClearable = {false}
                                                    />
                                                </td>
                                                <td >
                                                    <input
                                                        type="color"
                                                        className="form-control form-control-color p-1"
                                                        id={`color_${item.uidTipoAtencion}`}
                                                        defaultValue={item.color || "#000000"}
                                                        title="Elija un color"
                                                        onBlur={(ev) => {
                                                            if (ev.target.value !== item.color) {
                                                                editaTipoAtencion(ev, item.uidTipoAtencion);
                                                            }
                                                        }}
                                                        style={{ height: '38px', width: '100%' }}
                                                    />

                                                </td>
                                                <td > 
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        maxLength={2}
                                                        id= {`codigoTipoAtencion_${item.uidTipoAtencion}`}
                                                        defaultValue={item.codigoTipoAtencion.toUpperCase()}
                                                        onBlur={ (ev) => editaTipoAtencion( ev, item.uidTipoAtencion)}
                                                        onChange={ (ev) => pasarMayusculas( ev )}
                                                    />
                                                </td>
                                                <td >
                                                    <input
                                                        type= 'text'
                                                        className='form-control'
                                                        id={`sigla_${item.uidTipoAtencion}`}
                                                        defaultValue={item.sigla.toUpperCase()}
                                                        onBlur={ (ev) => editaTipoAtencion( ev, item.uidTipoAtencion)}
                                                        onChange={ (ev) => pasarMayusculas( ev )}

                                                    />

                                                    
                                                </td>
                                                <td >
                                                    <input
                                                        type= 'text'
                                                        className='form-control'
                                                        id={`orden_${item.uidTipoAtencion}`}
                                                        defaultValue={item.orden}
                                                        onBlur={ (ev) => editaTipoAtencion( ev, item.uidTipoAtencion)}

                                                    />
                                                </td>
                                                <td width={'5%'}>
                                                    <input
                                                        type= 'text'
                                                        className='form-control'
                                                        id={`prioritario_${item.uidTipoAtencion}`}
                                                        defaultValue={item.prioritario}
                                                        onBlur={ (ev) => editaTipoAtencion( ev, item.uidTipoAtencion)}
                                                    />
                                                </td>
                                                <td >
                                                    <input
                                                        type= 'text'
                                                        className='form-control'
                                                        id={`cantidad_${item.uidTipoAtencion}`}
                                                        defaultValue={item.cantidad}
                                                        onBlur={ (ev) => editaTipoAtencion( ev, item.uidTipoAtencion)}
                                                    />
                                                </td>
                                                <td >
                                                    {item.consecutivo}
                                                </td>
                                                <td >

                                                    <div className="form-check form-switch">
                                                        <input 
                                                            className="form-check-input" 
                                                            defaultChecked= { (item.indPrioridad === 1) ? "checked" : "" }
                                                            type="checkbox" 
                                                            id={`chkPrioritario_${item.uidTipoAtencion}`} 
                                                            onChange={ (ev) => editaTipoAtencion( ev, item.uidTipoAtencion)}
                                                        />

                                                        <label className="form-check-label" htmlFor="chkPrioritario_"></label>
                                                    </div>
                                                    
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>

                            <div className='pagination'>
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                {'<'}
                                </button> 
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(currentPage + 1)}
                                    disabled={currentItems.length < itemsPerPage}
                                >
                                {'>'}
                                </button>
                            </div>
                            
                        </div>
                    </div>
        
                </div>

                <TiposAtenHorarios
                    show={showHorarios}
                    onClose={() => setShowHorarios(false)}
                    tipoAtencion={selectedTipo}
                    horarios={horarios}
                    onAdd={handleAddHorario}
                    onEdit={handleEditHorario}
                    onDelete={handleDeleteHorario}
                />    
            </>
        )
    }
}
